"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllHashTypes = exports.AllEncryptionTypes = void 0;
const crypto = __importStar(require("../crypto"));
exports.AllEncryptionTypes = {
    AES_CBC: crypto.AesTypes.cbc,
    AES_GCM: crypto.AesTypes.gcm,
    AES_CTR: crypto.AesTypes.ctr,
    AES_ECB: crypto.AesTypes.ecb,
    AES_OFB: crypto.AesTypes.ofb,
    AES_CFB: crypto.AesTypes.cfb,
};
exports.AllHashTypes = {
    PBKDF2: crypto.HashTypes.pbkdf2,
    Standard: crypto.HashTypes.standard,
};
//# sourceMappingURL=index.js.map